// extracted by mini-css-extract-plugin
module.exports = {"root":"menu_root__a5cga","orientationvertical":"menu_orientationvertical__oa_IO","menuItem":"menu_menuItem__9Xl4Q","orientationhorizontal":"menu_orientationhorizontal__QaHi6"};